import type { CustomRouteContext } from 'core/universalRouter/types';
import type { Store } from 'react-redux';
import { fetchUserProfile } from 'store/userProfile/actions';
import { fetchDefaultSNSList } from 'store/snsDefaultList/actions';

import type { RouteContext } from 'universal-router';

export default async function userProfileResolver(
  context: RouteContext<CustomRouteContext>,
  store: Store,
): Promise<void> {
  const { dispatch } = store;

  await Promise.all([dispatch(fetchUserProfile()), dispatch(fetchDefaultSNSList())]);
}
